import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import menu from '@/assets/js/menu'
import * as Sentry from '@sentry/browser'

function redirectToAuth() {
  router.push({
    name: 'auth',
  })
}

export default {
  GET_ALL_PERMISSIONS_BY_MODEL({ commit, state }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.permissions.groupByModel}`,
      {
        params: {
          search: 'type:1',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setPermissions', state.permissions.concat(data.items))
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  async GET_ALL_PERMISSIONS_BY_MODEL_PILKI_PRO({ commit, state }) {
    await request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.permissions.groupByModel}`,
      {
        params: {
          search: 'type:2',
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setPermissionsPilkiPro', state.permissionsPilkiPro.concat(data.items))
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_ALL_PERMISSIONS_BY_MODEL_FOR_EMPLOYERS({ commit, state }) {
    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.permissions.groupByModel}`, {}, true).then(
      response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('setGroupPermissions', data.items)
          commit('setLoad', false)
        } else {
          // TODO: Show error dialog
        }
      },
    )
  },
  GET_PERMISSIONS_FOR_USER({ commit, state, dispatch }) {
    return new Promise(resolve => {
      request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.iam}`, {}, true)
        .then(res => {
          const user = res.data.data
          commit('setUser', user)

          Sentry.configureScope(scope => {
            scope.setUser({
              id: _.get(user, 'id', null),
            })

            scope.setTag('unit', _.get(user, 'unit.name', null))
            scope.setTag('unit_id', _.get(user, 'unit.id', null))
          })

          if (user.images.length) commit('setUserAvatar', user.images[0].filename)

          // пусть пока будет хз что это вообще
          commit('setMenu', menu)

          dispatch('GET_EMPLOYER_PERMISSIONS', {
            employerId: user.id,
            full: 1,
          }).then(() => {
            resolve()
          })
        })
        .catch(error => {
          // оставлю свитч для обработки различных статусов
          switch (error.response.status) {
            case 401:
              localStorage.removeItem('token')
              redirectToAuth()
              break
          }

          switch (error.response.data.code) {
            case 403:
              localStorage.removeItem('token')
              redirectToAuth()
              Vue.notify({
                group: 'hasBottomNavigation',
                type: 'error',
                text: 'Ваша учетка заблокирована',
              })
              break
          }
        })
    })
  },
}
